export default "__VITE_ASSET__Yf0JfvjO__"